import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useCallback, useState } from "react";

import MrpSheet from "./MrpSheet";
import MrpReport from "./MrpReport";
import MrpAnalytics from "./MrpAnalytics/MrpAnalytics";

/**
 * Analytics above the MRP table. More Filters (table FilterModal) scopes both the table and
 * analytics — same pattern as Styles. Table/Report toggle stays commented out.
 */
const MrpSheetShell = () => {
	const [view] = useState("table");
	const [scope, setScope] = useState({ filter: {}, search: "" });
	const [filterUi, setFilterUi] = useState({ open: () => {}, count: 0 });
	const onFilterUiChange = useCallback((api) => {
		setFilterUi(api || { open: () => {}, count: 0 });
	}, []);

	return (
		<Stack spacing={1.5} sx={{ width: "100%" }}>
			{/* ToggleButtonGroup Table View / Buying Report — intentionally left commented out. */}

			{view === "table" ? (
				<>
					<MrpAnalytics
						filter={scope.filter}
						search={scope.search}
						onMoreFilters={filterUi.open}
						activeFilterCount={filterUi.count}
					/>
					<Box sx={{ width: "100%" }}>
						<MrpSheet onFilterChange={setScope} onFilterUiChange={onFilterUiChange} />
					</Box>
				</>
			) : (
				<Box sx={{ width: "100%" }}>
					<MrpReport />
				</Box>
			)}
		</Stack>
	);
};

export default MrpSheetShell;
